import { create } from 'zustand';

import { FileUrlDTO, FileUrlResponse } from '@/types/api-types';

import { apiService } from '@/services/api-service';

interface FileUploadState {
  getFileLinks: (fileUrlDTO: FileUrlDTO) => Promise<FileUrlResponse>;
}

export const useFileUploadStore = create<FileUploadState>()(() => ({
  getFileLinks: async (fileUrlDTO: FileUrlDTO) => {
    const response = await apiService.getFileUrl(fileUrlDTO);
    return response;
  },
}));
